import {
  MAGAZINE_LIST_SEARCH, MAGAZINE_LIST_SEARCH_FAILURE, MAGAZINE_LIST_SEARCH_SUCCESS, MAGAZINE_DELETE, MAGAZINE_DELETE_FAILURE, MAGAZINE_DELETE_SUCCESS
} from './mutation-types'

export default {
  state: {
    magazines: [],
    magazineListNextPage: null,
    magazineListCurrentPage: null
  },
  getters: {
    magazineList: state => {
      return state.magazines
    },
    magazineListNextPage: state => {
      return state.magazineListNextPage
    },
    magazineListCurrentPage: state => {
      return state.magazineListCurrentPage
    }
  },
  actions: {
    [MAGAZINE_LIST_SEARCH] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/magazines'
      var callback = () => {}
      if (params) {
        if (params.url) {
          url = params.url
        }
        if ('callback' in params) {
          callback = params.callback
        }
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MAGAZINE_LIST_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MAGAZINE_LIST_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MAGAZINE_DELETE] ({dispatch, state, commit}, params = null) {
      console.log('MAGAZINE_DELETE:' + params.id)
      var data = params.data
      var url = '/master/magazines/' + params.id
      dispatch('apiDelete', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MAGAZINE_DELETE_FAILURE, res.data)
          } else {
            commit(MAGAZINE_DELETE_SUCCESS, {data: res.data, callback: params.callback})
            window.location.reload(false)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MAGAZINE_LIST_SEARCH_FAILURE] (state, params) {
      console.log('MAGAZINE_LIST_SEARCH_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [MAGAZINE_LIST_SEARCH_SUCCESS] (state, params) {
      console.log('MAGAZINE_LIST_SEARCH_SUCCESS')
      var data = params.data
      if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
        state.magazines = state.magazines.concat(data.data)
        state.magazineListCurrentPage = data.meta['current-page']
      } else {
        state.magazines = data.data
        state.magazineListCurrentPage = 1
      }
      if (data.links && data.links['next']) {
        state.magazineListNextPage = data.links['next']
      } else {
        state.magazineListNextPage = null
      }
      if (params.callback) {
        params.callback()
      }
    },
    [MAGAZINE_DELETE_FAILURE] (state, data) {
      console.log('MAGAZINE_DELETE_FAILURE')
    },
    [MAGAZINE_DELETE_SUCCESS] (state, data) {
      console.log('MAGAZINE_DELETE_SUCCESS')
      var callback = data.callback
      callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/magazine-list.js